<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main max-w" id="page-content-main">
    <div class="">
      <epay-lib-employer-creditcard
        [baseurl]="baseurl"
        [termsContent]="termsContent"
        [creditCardVendorId]="creditCardVendorId"
        [creditCardDisclaimer]="creditCardDisclaimer"
        [validateCaseNumber]="validateCaseNumber"
        [allowZeroAmount]="allowZeroAmount"
        [clientName]="clientName"
        >
      </epay-lib-employer-creditcard>
    </div>
  </div>
</epay-page-content>
